import BaseChart from './BaseChart'
import ItemsHelper from '../chart_helpers/ItemsHelper'
import RootHelper from '../chart_helpers/RootHelper'
import AxisHelper, { cleanCollisions, continuousExtentParts } from '../chart_helpers/AxisHelper'
import { continuousExtent } from '../chart_helpers/AxisHelper'
import SelectableHelper from '../chart_helpers/SelectableHelper'
import ExportHelper from '../chart_helpers/ExportHelper'
import * as COLORS from '../utils/colorUtils'

import {
  curveCardinal as d3_curveCardinal,
  curveLinear as d3_curveLinear,
  line as d3_line,
  area as d3_area,
} from 'd3-shape'

import SizeHelper from '../chart_helpers/SizeHelper'

export default class LineChartChart extends BaseChart {
  constructor(...args) {
    super(...args)
  }
  static defaultConfig = {
    /**
     * Type of curve. `smooth` curves will interpolate between the data poitns. `shapr` curves will be composed of straight line segments.
     */
    curve: {
      type: String,
      default: 'smooth',
      options: ['smooth', 'sharp'],
      exposed: true,
    },
    /**
     * Show/hide the data points that form each line.
     */
    showPoints: {
      type: Boolean,
      default: true,
      exposed: true,
    },
    SelectableHelper: {
      enableHighlight: true,
      magnetic: true,
    },
    AxisHelper: {
      x: {
        getExtent: function(data) {
          let extent = continuousExtent(data, d => d.id)
          // if(this.getValueType('x')==='D' && this.config.AxisHelper.x.scale==='linear') extent = padLinear(extent,0.2)
          return extent
        },
        // valueFormat: '[D]%d %b'
      },
      y: {
        getExtent: function(data) {
          let extent, extentParts
          if (this.config.mode === 'lines') {
            extentParts = continuousExtentParts(data)
            // console.log("extent parts",extentParts)
            extent = continuousExtent(extentParts)
          } else {
            extentParts = continuousExtentParts(data, d => [d.y0, d.y1])
            // console.log("extent parts",extentParts)
            extent = continuousExtent(extentParts)
          }

          // extent = padLinear(extent,0.2)

          extent = cleanCollisions(this.axes.y, extent, extentParts)

          return extent

          // if(originalExtent[0]>0) extent[0]=0
        },
      },
    },
  }
  static helpers = [
    RootHelper,
    ItemsHelper,
    SelectableHelper,
    SizeHelper,
    AxisHelper,
    ExportHelper,
    // {
    //   class: AxisHelper,
    //   config: {
    //     x:{
    //       getExtent: function (data){
    //         let extent = continuousExtent(data,(d)=>d.id)
    //         // if(this.getValueType('x')==='D' && this.config.AxisHelper.x.scale==='linear') extent = padLinear(extent,0.2)
    //         return extent
    //       },
    //       // valueFormat: '[D]%d %b'
    //     },
    //     y:{
    //       getExtent: function (data){
    //         let extent,extentParts
    //         if(this.config.mode==='lines'){
    //           extentParts = continuousExtentParts(data)
    //           // console.log("extent parts",extentParts)
    //           extent = continuousExtent(extentParts)

    //         } else {
    //           extentParts = continuousExtentParts(data,(d)=>[d.y0,d.y1])
    //           // console.log("extent parts",extentParts)
    //           extent = continuousExtent(extentParts)
    //         }

    //         // extent = padLinear(extent,0.2)

    //         extent = cleanCollisions(this.axes.y, extent, extentParts)

    //         return extent

    //         // if(originalExtent[0]>0) extent[0]=0

    //       }
    //     }
    //   }
    // },
  ]
  checkConsistency() {
    return true
  }
  draw() {
    const self = this
    if (this.config.mode === 'lines') {
      let line = d3_line()
        .defined(d => d.value !== null)
        .curve(this.config.curve === 'smooth' ? d3_curveCardinal : d3_curveLinear)
        .x(d => this.axes.x.func.scale()(d.id))
        .y(d => this.axes.y.func.scale()(d.value))

      // this.itemsEnter.append('path')
      this.parentItemsEnter.append('path').attr('fill', 'none')

      // this.itemsEnter.call(drawItem,'enter')
      // this.parentItemsEnter.select('path').attr('d',(d)=>line(d.value)).attr('stroke',(d)=>this.color(d))

      // this.itemsEnterTrans.call(drawItem)
      this.parentItemsEnter
        .select('path')
        .attr('d', d => line(d.value))
        .attr('stroke', d => this.color(d))
        // .attr('stroke-dasharray',(d)=>this.strokeDasharray(d))
        .each(function() {
          this._totalLength = this.getTotalLength()
        })
        .attr('stroke-dasharray', function(d) {
          var dashing = self.strokeDasharray(d)
          if (dashing === 'none') dashing = '1 0'
          var dashLength = dashing
            .split(/[\s,]/)
            .map(function(a) {
              return parseFloat(a) || 0
            })
            .reduce(function(a, b) {
              return a + b
            })
          var dashCount = Math.ceil(this._totalLength / dashLength)
          var newDashes = new Array(dashCount).join(dashing + ' ')
          var dashArray = newDashes + ' 0, ' + this._totalLength
          return dashArray
        })
        .attr('stroke-dashoffset', function() {
          return this._totalLength
        })

      this.parentItemsEnterTrans.select('path').attr('stroke-dashoffset', 0)

      this.parentItems.select('path').attr('stroke-dasharray', 'none')
      // .attr('d',(d)=>line(d.value))

      this.parentItemsTrans
        .select('path')
        .attr('d', d => line(d.value))
        .attr('stroke', d => this.color(d))
        .attr('stroke-dasharray', d => this.strokeDasharray(d))

      this.parentItemsExitTrans.style('opacity', 0)
    } else {
      let area = d3_area()
        .curve(this.config.curve === 'smooth' ? d3_curveCardinal : d3_curveLinear)
        .x(d => this.axes.x.func.scale()(d.id))
        .y0(d => this.axes.y.func.scale()(d.y0))
        .y1(d => this.axes.y.func.scale()(d.y1))
      let line = d3_line()
        .defined(d => d.value !== null && d.value !== void 0)
        .curve(this.config.curve === 'smooth' ? d3_curveCardinal : d3_curveLinear)
        .x(d => this.axes.x.func.scale()(d.id))
        .y(d => this.axes.y.func.scale()(d.y1))
      this.parentItemsEnter.append('path').attr('class', 'area')
      this.parentItemsEnter.append('path').attr('class', 'separator')
      // this.parentItemsEnter.append('path')
      // this.parentItems.select('path').attr('d',(d)=>area(d.value)).attr('fill',(d)=>this.color(d))
      this.parentItemsEnter
        .select('.area')
        .attr('d', d => {
          return area(
            d.value.map(dd => {
              return { id: dd.id, y0: 0, y1: 0 }
            })
          )
        })
        .attr('fill', d => this.color(d))
      this.parentItemsEnterTrans
        .select('.area')
        .attr('d', d => area(d.value))
        .attr('fill', d => this.color(d))

      this.parentItemsTrans
        .select('.area')
        .attr('d', d => area(d.value))
        .attr('fill', d => this.color(d))

      this.parentItemsEnter
        .select('.separator')
        .attr('d', d => {
          return line(
            d.value.map(dd => {
              return { id: dd.id, y0: 0, y1: 0 }
            })
          )
        })
        .attr('fill', 'none')
        .attr('stroke', (d, i, arr) => (i < arr.length - 1 ? '#fff' : 'none'))
        .attr('stroke-width', 2)
      this.parentItemsEnterTrans
        .select('.separator')
        .attr('d', d => line(d.value))
        .attr('stroke', (d, i, arr) => (i < arr.length - 1 ? '#fff' : 'none'))
      this.parentItemsTrans
        .select('.separator')
        .attr('d', d => line(d.value))
        .attr('stroke', (d, i, arr) => (i < arr.length - 1 ? '#fff' : 'none'))

      this.parentItemsExitTrans.style('opacity', 0)

      this.parentItems.merge(this.parentItemsEnter).sort((a, b) => b.value[0].y0 - a.value[0].y0)
    }

    let items = this.items.merge(this.itemsEnter)
    let breakpoints = items
      .raise()
      .selectAll('.break-point')
      .data(d => {
        return this.config.showPoints && d.value != null ? [d] : []
      })
    breakpoints
      .exit()
      .transition()
      .style('opacity', 0)
      .remove()
    let breakpointsEnter = breakpoints
      .enter()
      .append('g')
      .attr('class', 'break-point')
    breakpointsEnter.append('circle')
    breakpointsEnter.attr(
      'transform',
      d =>
        `translate(${this.axes.x.func.scale()(d.id)},${this.axes.y.func.scale()(d.y1 || d.value)})`
    )

    this.itemsEnter
      .select('.break-point')
      .attr(
        'transform',
        d =>
          `translate(${this.axes.x.func.scale()(d.id)},${this.axes.y.func.scale()(
            d.y1 || d.value
          )})`
      )
      .select('circle')
      .attr(
        'fill',
        this.config.skin === 'light' ? COLORS.SKIN_BACKGROUND : COLORS.SKIN_BACKGROUND_DARK
      )
      .attr('stroke', d => {
        this.color({ id: d.parentId })
        return this.color({ id: d.parentId })
      })
      .attr('r', 0)
    this.itemsEnterTrans
      .select('.break-point')
      .select('circle')
      .attr('r', d => {
        return d.interpolated === true ? 0 : 3
      })
      .style('opacity', d => {
        return !self.selection.length || self.selection.map(d => d.id).includes(d.parentId) ? 1 : 0
      })
    /* .attr('r', d => {
        return !self.selection.length || self.selection.map(d => d.id).includes(d.parentId) ? 3 : 1
      }) */
    this.itemsTrans
      .select('.break-point')
      .attr(
        'transform',
        d =>
          `translate(${this.axes.x.func.scale()(d.id)},${this.axes.y.func.scale()(
            d.y1 || d.value
          )})`
      )
      .select('circle')
      .attr(
        'fill',
        this.config.skin === 'light' ? COLORS.SKIN_BACKGROUND : COLORS.SKIN_BACKGROUND_DARK
      )
      .attr('stroke', d => this.color({ id: d.parentId }))
      .attr('r', 3)
      .style('opacity', d => {
        return !self.selection.length || self.selection.map(d => d.id).includes(d.parentId) ? 1 : 0
      })
    /* .attr('r', d => {
        return !self.selection.length || self.selection.map(d => d.id).includes(d.parentId) ? 3 : 1
      }) */
    this.itemsExitTrans.select('circle').attr('opacity', 0)
  }
  /* setHighlightedFunc(sel) {
    // console.log("should set hightliht",d,this)
    sel.selectAll('.item').style('opacity', 1)
  }
  unsetHighlightedFunc(sel) {
    // console.log("should unset hightliht",d,this)
    sel.selectAll('.item').style('opacity', 0)
  }

  setSelectedFunc(sel) {
    // console.log("should set hightliht",d,this)
    sel.attr('stroke-width', 1)
  }
  unsetSelectedFunc(sel) {
    // console.log("should unset hightliht",d,this)
    sel.attr('stroke-width', 1)
  } */
}
